import { Boundaries } from "@planzone/core";
import { removeOrganizationalUnitError } from "@planzone/dto";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  request: { isPending: false, isSuccessful: false, isFailure: false },
  error: removeOrganizationalUnitError,
};

function handleRequest(state: State): State {
  return {
    ...state,
    error: removeOrganizationalUnitError,
    request: setRequestStateToPending(),
  };
}

function handleSuccess(state: State): State {
  return {
    ...state,
    error: removeOrganizationalUnitError,
    request: setRequestStateToSuccess(),
  };
}

function handleFailure(
  state: State,
  { error }: Boundaries["removeOrganizationalUnit"]["failure"],
): State {
  return { ...state, error, request: setRequestStateToFailure() };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeOrganizationalUnitRequested]: handleRequest,
    [events.removeOrganizationalUnitSucceeded]: handleSuccess,
    [events.removeOrganizationalUnitFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
